<script lang="ts">
  import SEO from '$lib/components/seo/SEO.svelte'
  import ArticleHeaderIngress from '$lib/components/header/ArticleHeaderIngress.svelte'
  import Body from '$lib/components/article/Body.svelte'
  import ExternalUrls from '$lib/components/article/ExternalUrls.svelte'
  import RelevantPages from '$lib/components/article/RelevantPages.svelte'
  import RelevantFaqs from '$lib/components/article/RelevantFaqs.svelte'
  import type { LoadResult, Resource } from '$lib/types/ServicePageTypes.js'
  import { beforeUpdate, onDestroy } from 'svelte'
  import BreadcrumbStore from '$lib/stores/breadcrumbStore'
  import BodyWrapper from '$lib/wrappers/BodyWrapper.svelte'

  export let data: LoadResult<Resource>
  const { title, ingress, image, body, seo, serviceArea, externalUrls, relevantFaqs, relevantPages, useSimpleHeader } =
    data.props

  beforeUpdate(() => {
    BreadcrumbStore.set(title)
  })

  onDestroy(() => {
    BreadcrumbStore.set('')
  })
</script>

<SEO title={seo?.metaTitle || title} description={seo?.metaDescription || ingress} />
<!--usikker på denne -->
<!--<GeneralSectionWrapper class="bg-base-white !py-0">-->
<ArticleHeaderIngress {image} {useSimpleHeader} headerText={title}>
  <div class="">{ingress || ''}</div>
</ArticleHeaderIngress>
<!--</GeneralSectionWrapper>-->

<Body {body} />
{#if relevantFaqs}
  <BodyWrapper class="bg-base-white">
    <RelevantFaqs {relevantFaqs} linkToAllFaqsFilter={serviceArea} />
  </BodyWrapper>
{/if}
<ExternalUrls {externalUrls} />
<RelevantPages {relevantPages} />
